"use strict";
exports.__esModule = true;
var modal = function () {
    /* Variable inits */
    var openedModals = [];
    var modalSmall = document.querySelector('.modal-small');
    var modalContainer = document.querySelector('.modal-container');
    //
    var closeModal = function () {
        openedModals[0].classList.remove('open');
        openedModals[0].setAttribute('tabindex', '');
        if (openedModals.length < 2)
            modalContainer.classList.remove('open');
        openedModals.shift();
        if (openedModals[0])
            openedModals[0].focus();
    };
    //
    var openModal = function (modalElement) {
        openedModals.unshift(modalElement);
        modalElement.classList.add('open');
        modalContainer.classList.add('open');
        modalElement.setAttribute('tabindex', '-1');
        modalElement.focus();
    };
    //
    var modalHandler = function (e) {
        var target = e.target;
        var modalAttribute = target.getAttribute('data-modal');
        switch (modalAttribute) {
            case 'small':
                openModal(modalSmall);
                break;
            case 'close':
                closeModal();
                break;
            default:
                break;
        }
    };
    //Creates event listeners
    var handleEvents = function () {
        document.addEventListener('click', function (e) { modalHandler(e); });
    };
    var init = function () {
        handleEvents();
    };
    init();
};
exports["default"] = modal;
